import {ALLOWED_NEGATIVE_DISCOUNT_FIELDS} from './discount_constraints'

export const validateDiscountPercentage = value => {
	const numberValue = Number(value)

	if (isNaN(numberValue) || numberValue < 1 || numberValue > 100) {
		return {
			valid: false,
			message: 'form.validation.discount_pct',
		}
	}
	return {valid: true}
}

const nonZeroDecimalPattern = '(?!0+(\\.0+)?$)\\d+(\\.\\d+)?$'
const floatPattern = new RegExp(`^${nonZeroDecimalPattern}`)
const negativeFloatPattern = new RegExp(`^-?${nonZeroDecimalPattern}`)

export const validateDiscountAmount = (value, {getFormData}) => {
	const {discount} = getFormData()

	const isAllowedNegative = ALLOWED_NEGATIVE_DISCOUNT_FIELDS.includes(discount)

	// Dynamically inject the optional minus sign if allowed
	const validationRegex = isAllowedNegative ? negativeFloatPattern : floatPattern
	const isValid = validationRegex.test(value)

	if (!isValid) {
		return {
			valid: false,
			message: `form.validation.discount_amount_allowed_negative_${isAllowedNegative}`,
		}
	}

	return {valid: true}
}
